import { Component, ElementRef, forwardRef, Input } from '@angular/core';

import { PointCategory } from '../../../../models';
import { MapFieldPointLogicService, SiteMapLogicService } from '../../../../services/logic-services';
import { FieldPointIconComponent } from '../../../../shared/components/field-point-icon/field-point-icon.component';
import { FieldPointIconsSize } from '../../../../shared/enums';

@Component({
    selector: 'kh-field-point-info-window',
    templateUrl: './field-point-info-window.html',
    styleUrls: ['./field-point-info-window.scss'],
    imports: [
        forwardRef((): typeof FieldPointIconComponent => FieldPointIconComponent)
    ]
})
export class FieldPointInfoWindowComponent {
    @Input() pointCategory!: PointCategory;
    @Input() columnIdentifierValue: string;
    @Input() identifier?: string;

    fieldPointIconsSize = FieldPointIconsSize;

    constructor(
        private _elementRef: ElementRef,
        private _mapFieldPointLogicService: MapFieldPointLogicService,
        private _siteMapLogicService: SiteMapLogicService
    ) { }

    click(): void {
        if (this._mapFieldPointLogicService.model.isEditingFieldPointCoordinates || this._mapFieldPointLogicService.model.fieldPointData) {
            return;
        }

        const markerIndex = this._mapFieldPointLogicService.model.categoryMarkerComponentRefs.findIndex(ref => ref.instance.identifier === this.identifier);
        const marker = this._mapFieldPointLogicService.model.categoryMarkers[markerIndex];

        this.closeInfoWindow();
        this._siteMapLogicService.model.pinnedInfoWindow.setContent(this._elementRef.nativeElement);
        this._siteMapLogicService.model.pinnedInfoWindow.setPosition(marker.position);
        this._siteMapLogicService.model.pinnedInfoWindow.open({ anchor: marker, map: marker.map });

        this._siteMapLogicService.model.map.panTo(marker.position);
        this._mapFieldPointLogicService.setMarkerBeingPreviewed(this.identifier, marker);
    }

    hover(): void {
        const markerIndex = this._mapFieldPointLogicService.model.categoryMarkerComponentRefs.findIndex(ref => ref.instance.identifier === this.identifier);
        const marker = this._mapFieldPointLogicService.model.categoryMarkers[markerIndex];

        if (this._mapFieldPointLogicService.model.categoryMarkerBeingPreviewed === marker) {
            return;
        }

        this._mapFieldPointLogicService.clearHideInfoWindowTimeout();
        this._siteMapLogicService.model.infoWindow.setContent(this._elementRef.nativeElement);
        this._siteMapLogicService.model.infoWindow.setPosition(marker.position);
        this._siteMapLogicService.model.infoWindow.open({ anchor: marker, map: marker.map });
    }

    hoverOut(): void {
        this.closeInfoWindow();
    }

    closeInfoWindow(): void {
        this._siteMapLogicService.closeInfoWindow();
    }
}
